import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import axios from 'axios'
import vuetify from '@/plugins/vuetify'
import i18n from './i18n';
import { BootstrapVue } from 'bootstrap-vue'
import { getParamQueryTheme, isStrEmpty } from './utils/utils'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.prototype.$isReprintDialogShowing = false
Vue.prototype.$currentPrintContext = null
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

// Capture app-version from URL before router init, otherwise the redirect
// to /login replaces the URL and the query param is lost before App.vue mounts.
const urlAppVersion = getParamQueryTheme('app-version')
if (!isStrEmpty(urlAppVersion)) {
    store.commit('SET_APK_VERSION_NUMBER', urlAppVersion)
}

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
